// delete this hook and use useFindingStatus resolved
import { useMemo } from 'react';
import { useGlobalSettingsContext } from 'contexts/GlobalSettingsContext';
import { FINDING_STATUS } from "views/Findings/Constants";
import { difference } from 'lodash';

export default function useResolvedFindingStatusTemp() {
    const { mitigatedStatus, disabledFindingStatus } = useGlobalSettingsContext();
    const resolvedStatus = useMemo(() => {
        let statuses = [...mitigatedStatus, FINDING_STATUS.MITIGATED];
        statuses = difference(statuses, disabledFindingStatus)
        
        return statuses;
    }, [
        mitigatedStatus,
        disabledFindingStatus,
    ]);

    return resolvedStatus;
}